module.exports = __webpack_public_path__ + "home/en-US/images/gif/shortcut_animation-f15f3907096b37d62138d5c21e028aea.gif";


//////////////////
// WEBPACK FOOTER
// ./home/en-US/images/gif/shortcut_animation.gif
// module id = u4Xe
// module chunks = 0